import clsx from 'clsx';

import s from './inputs.module.scss';

export const Radio = ({
  checked,
  onChange,
  label,
  className,
  id,
  name,
}: {
  checked: boolean;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  label: string;
  className?: string;
  /** Lets something outside the control label it — see SettingRow's `selectFor`. */
  id?: string;
  /** Groups the radios, so arrow keys walk the set and only one can be on. */
  name?: string;
}) => {
  /* A <label> with no text is not a label, and nesting one inside the row's
     own <label> would be invalid besides. So the wrapper is a <span> whenever
     there is nothing to say — which is every case where the row carries the
     text instead. */
  const Wrapper = label ? 'label' : 'span';
  return (
    <Wrapper className={clsx(s.Radio, className)}>
      <div className={clsx(s.circle, checked && s.checked)} />
      {label && <div>{label}</div>}
      <input
        id={id}
        name={name}
        checked={checked}
        className={s.input}
        type="radio"
        onChange={onChange}
      />
    </Wrapper>
  );
};
